import React from 'react';

import { Field, SelectField } from 'src/components/finalForm';
import { useCurrentUserVerifier } from 'src/hooks/verifier';

import { InboxFilterFieldProps, InboxFilterFormFields } from '../types';
import { getVerificationRequestTypes } from '../utils';

export const InboxFilterVerificationRequestTypeField: React.FC<InboxFilterFieldProps> = ({
  disabled,
}) => {
  const { verifierType } = useCurrentUserVerifier();

  const options = React.useMemo(() => {
    const requestTypeList = getVerificationRequestTypes(verifierType);
    return requestTypeList.map(requestType => ({ label: requestType, value: requestType }));
  }, [verifierType]);

  return (
    <Field
      fullWidth
      component={SelectField}
      multiple
      options={options}
      name={InboxFilterFormFields.verificationRequestTypes}
      label="Request Type"
      disabled={disabled}
    />
  );
};
